import { normalizeInputDigits } from './localizedInput';
import { FTP_PERCENT_MAX } from './workoutStructure';
export type PowerInputUnit = 'percent' | 'watts';
export function parseIntensityInput(text: string): number | null {
  const normalized = normalizeInputDigits(text).replace(/٫/g, '.').trim();
  if (!/^(?:\d+(?:\.\d*)?|\.\d+)$/.test(normalized)) return null;
  const value = Number(normalized);
  return Number.isFinite(value) ? value : null;
}
export const powerInputLimit = (unit: PowerInputUnit, ftp: number) => unit === 'watts' ? FTP_PERCENT_MAX * ftp / 100 : FTP_PERCENT_MAX;
export function resolvePowerInput(minText: string, maxText: string, unit: PowerInputUnit, ftp: number, single = false) {
  const min = parseIntensityInput(minText);
  const max = single ? min : parseIntensityInput(maxText);
  const limit = powerInputLimit(unit, ftp);
  if (unit === 'watts' && !(ftp > 0)) return { valid: false, error: 'ftpRequired' } as const;
  if (min == null || max == null) return { valid: false, error: 'numberRequired' } as const;
  if (min > limit || max > limit) return { valid: false, error: 'outOfBounds', limit } as const;
  if (min > max) return { valid: false, error: 'invalidRange' } as const;
  const toPercent = (value: number) => unit === 'watts' ? Number((value * 100 / ftp).toFixed(6)) : value;
  return { valid: true, minValue: toPercent(min), maxValue: toPercent(max) } as const;
}
export function nudgeIntensityInput(text: string, delta: number, limit: number): string {
  return String(Number(Math.min(limit, Math.max(0, (parseIntensityInput(text) ?? 0) + delta)).toFixed(6)));
}
